import api from '../../../App/socket';

export const getLeads = (params) => {
    const {
        limit,
        offset,
        customerPhone,
        ref_lead_source,
    } = params;

    return api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'getCustomersByLeadSource',
        options: {
            limit,
            offset,
            where: {
                ref_lead_source,
                customerPhone,
            },
        },
    });
};

export const countLeads = (params) => {
    const {
        customerPhone,
        ref_lead_source,
    } = params;

    return api.send({
        api: 'module',
        module: 'Leads',
        classMethod: 'getCustomersByLeadSource',
        options: {
            where: {
                ref_lead_source,
                customerPhone,
            },
            isCount: true,
        },
    });
};



// WEBPACK FOOTER //
// ./src/modules/Leads/CustomersList/requests/leads.requests.js